import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FunctionsService } from 'src/app/modules/core/services/functions.service';

@Component({
    selector: 'app-public-wrapper',
    templateUrl: './public-wrapper.component.html',
    styleUrls: ['./public-wrapper.component.scss']
})
export class PublicWrapperComponent implements OnInit {

    page: PageTypes
    page_types = {
        QRS: PageTypes.QRS,
        POPUPS: PageTypes.POPUPS,
    }

    constructor(
        private router: Router,
        private location: Location,
        private functionService: FunctionsService
    ) {
        this.page = this.functionService.ltrim(this.location.prepareExternalUrl(this.location.path()), "/").split("/")[0] as PageTypes
        if (![PageTypes.POPUPS, PageTypes.QRS].includes(this.page)) {
            this.router.navigateByUrl("/404")
            return
        }
    }

    ngOnInit(): void {
    }

}

enum PageTypes {
    QRS = "qrs",
    POPUPS = "popups",
}
